import type { FhirResource } from 'fhir/r4';

export const findResourceByType = <
  TResult extends FhirResource,
  T extends FhirResource = FhirResource,
>(
  resourceType: TResult['resourceType'],
  resources: T[] = [],
): TResult =>
  resources.find(
    (resource) => resource.resourceType === resourceType,
  ) as unknown as TResult;

export const findResourcesByType = <
  TResult extends FhirResource,
  T extends FhirResource = FhirResource,
>(
  resourceType: TResult['resourceType'],
  resources: T[] = [],
): TResult[] =>
  resources.filter(
    (resource) => resource.resourceType === resourceType,
  ) as unknown as TResult[];
